
import {
  defineComponent, ref, onMounted, watch, onBeforeUnmount, nextTick,
} from 'vue';
// 萤石云
import camera from './camera.vue';
// 28181
import cameraStd from './cameraStd.vue';

export default defineComponent({
  components: {
    camera,
    cameraStd,
  },
  props: {
    popupData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props, { emit, }) {
    const cameraRef = ref<any>(null);
    const isCamera = ref<boolean>(true);

    // 视频接入平台类型（萤石云/28181）28181逐步替换萤石云，后期删除萤石云组件
    const cameraType = ref<'camera'|'cameraStd'|''>('camera');
    const cancelPop = () => {
      isCamera.value = false;
      cameraType.value = '';
      emit('close');
    };

    const initCamera = (val:any) => {
      isCamera.value = true;
      const chimneyNo = val?.Chimneys?.[0]?.chimneyNo;

      cameraType.value = chimneyNo === '28181' ? 'cameraStd' : 'camera';
      const param = chimneyNo === '28181' ? val?.name : chimneyNo;

      nextTick(() => {
        cameraRef.value.setParamData(param);
      });
    };

    watch(
      () => props.popupData,
      (val) => {
        initCamera(val);
      }
    );

    onMounted(() => {
      initCamera(props.popupData);
    });

    onBeforeUnmount(() => {
      //
    });

    return {
      cancelPop,
      cameraRef,
      isCamera,
      cameraType,
    };
  },
});
